import classNames from 'classnames';

import { policyWrapper } from '../../../../styles/PolicyStyles';

const PrivacyPolicy_v18 = (): JSX.Element => {
  return (
    <article css={policyWrapper}>
      <p className="f13 c_gray">
        (주)중고나라(이하 &quot;회사&quot;라 함)는 회사가 운영하는 인터넷 사이트
        및 모바일 애플리케이션(이하 “중고나라” 함)을 이용하는 회원들의
        개인정보를 매우 중요하게 생각하며, 통신비밀보호법, 전기통신사업법,
        정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보 보호법 등
        정보통신서비스제공자가 준수하여야 할 관련 법령상의 개인정보보호 규정을
        준수하고, 이를 “중고나라” 이용약관에 공개하여 고객이 언제나 용이하게
        열람할 수 있도록 하고 있습니다. 회사는 정부의 법률 및 지침 변경 등에
        따라 수시로 개인정보처리방침을 바꿀 수 있고, 이에 따른 개인정보
        처리방침의 지속적인 개선을 위해 필요한 절차를 정하고 있습니다.
      </p>
      <p className="f13 c_gray mt10">
        회사는 관련 법령에 의거한 개인정보 취급처리를 정하여 이용자의 권익
        보호에 최선을 다하고 있으며, 개인정보 처리방침을 개정하거나 변경할
        때에는 서비스 내 공지사항에 해당 내용을 알리고 있습니다. 이용자들께서는
        서비스 방문 시 수시로 확인하여 주시기 바랍니다.
      </p>
      <p className="f13 c_gray mt10">
        회사의 개인정보처리방침은 다음과 같은 내용을 담고 있습니다.
      </p>
      <ol className="f13 c_gray mt10 list_desc">
        <li className="relative pd_l20 mt5">
          <span className="desc">1.</span>
          <p>개인정보 수집 및 이용목적</p>
        </li>
        <li className="relative pd_l20 mt5">
          <span className="desc">2.</span>
          <p>개인정보 수집 항목</p>
        </li>
        <li className="relative pd_l20 mt5">
          <span className="desc">3.</span>
          <p>개인정보 수집 방법</p>
        </li>
        <li className="relative pd_l20 mt5">
          <span className="desc">4.</span>
          <p>개인정보의 보유 및 이용기간</p>
        </li>
        <li className="relative pd_l20 mt5">
          <span className="desc">5.</span>
          <p>개인정보의 제3자 제공</p>
        </li>
        <li className="relative pd_l20 mt5">
          <span className="desc">6.</span>
          <p>개인정보의 처리위탁</p>
        </li>
        <li className="relative pd_l20 mt5">
          <span className="desc">7.</span>
          <p>개인정보의 파기 절차 및 방법</p>
        </li>
        <li className="relative pd_l20 mt5">
          <span className="desc">8.</span>
          <p>이용자의 권리</p>
        </li>
        <li className="relative pd_l20 mt5">
          <span className="desc">9.</span>
          <p>개인정보의 안정성 확보 조치</p>
        </li>
        <li className="relative pd_l20 mt5">
          <span className="desc">10.</span>
          <p>이용자의 의무</p>
        </li>
        <li className="relative pd_l20 mt5">
          <span className="desc">11.</span>
          <p>링크(사이트)에 대한 안내</p>
        </li>
        <li className="relative pd_l20 mt5">
          <span className="desc">12.</span>
          <p>개인정보보호 책임자</p>
        </li>
        <li className="relative pd_l20 mt5">
          <span className="desc">13.</span>
          <p>개인정보처리방침의 변경</p>
        </li>
      </ol>
      <dl
        className={classNames(
          'f13',
          'c_gray',
          'mt20',
          'list_desc',
          'termsCont',
        )}
      >
        <dt className="relative pd_l20">
          <span className="desc">
            <strong>1.</strong>
          </span>
          <p>
            <strong>개인정보 수집 및 이용 목적</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            회사가 이용자의 개인정보를 수집 및 이용하는 목적은 다음과 같습니다.
          </p>
          <table className={classNames('mt10', 'termsTable')}>
            <thead>
              <tr>
                <th className={'w30'}>
                  <p>
                    <strong>구분</strong>
                  </p>
                </th>
                <th className={'w70'}>
                  <p>
                    <strong>이용 목적</strong>
                  </p>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p>회원관리</p>
                </td>
                <td>
                  <p>회원제 서비스 이용에 따른 회원식별</p>
                  <p>불량회원의 부정이용 방지와 중복가입방지</p>
                  <p>가입의사 확인</p>
                  <p>고객문의, 불만접수 및 처리, 분쟁조정을 위한 기록보존</p>
                  <p>고지사항 전달</p>
                  <p>부정거래 방지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>
                    서비스 제공에 관한 계약의 이행 및 서비스 제공에 대한 수집
                  </p>
                </td>
                <td>
                  <p>회원간 거래 서비스 제공</p>
                  <p>콘텐츠 제공, 이벤트/경품당첨 결과안내 및 상품배송</p>
                  <p>금융거래 관련 본인인증 및 금융서비스</p>
                  <p>부정거래 방지</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p>마케팅 및 광고에 활용</p>
                </td>
                <td>
                  <p>최적화된 서비스 제공</p>
                  <p>새로운 상품 또는 서비스 안내</p>
                  <p>회원관심사에 부합하는 서비스 및 이벤트 기획</p>
                  <p>인구통계학적 특성에 따른 서비스 제공 및 광고 게재</p>
                  <p>웹페이지 접속 빈도 파악</p>
                  <p>중고나라 상품/서비스의 이용실적 분석</p>
                  <p>이벤트 등 광고성 정보전달</p>
                  <p>서비스 및 상품 안내</p>
                </td>
              </tr>
            </tbody>
          </table>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>2.</strong>
          </span>
          <p>
            <strong>개인정보 수집 항목</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                회사는 기본적인 서비스 제공을 위한 필수 정보만을 수집하고 있으며
                이용자 각각의 기호와 필요에 맞는 서비스를 제공하기 위하여 정보
                수집 때 별도 동의를 얻고 있습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                회사는 이용자의 기본적 인권을 침해할 우려가 있는 민감한
                개인정보(인종 및 민족, 사상 및 신조, 출신지 및 본적지, 정치적
                성향 및 범죄기록, 건강상태 및 성생활 등)는 수집하지 않습니다.
                그리고, 어떤 경우에 라도 입력하신 정보를 이용자들에게 미리 밝힌
                목적 이외의 다른 목적으로는 사용하지 않으며 외부로 유출하지
                않습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">③</span>
              <p>회사는 다음과 같이 개인정보를 수집하여 이용합니다.</p>
              <table className={classNames('mt10', 'termsTable')}>
                <thead>
                  <tr>
                    <th className={'w25'}>
                      <p>
                        <strong>구분</strong>
                      </p>
                    </th>
                    <th className={'w25'}>
                      <p>
                        <strong>수집/이용 항목</strong>
                      </p>
                    </th>
                    <th className={'w25'}>
                      <p>
                        <strong>수집/이용 목적</strong>
                      </p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <p>회원공통</p>
                    </td>
                    <td>
                      <p>
                        이름, 생년월일, 성별, 아이디(ID), 비밀번호,
                        휴대전화번호, 이메일, 중복가입번호(DI), 연계정보(CI),
                        광고식별자(ADID/IDFA), 방문식별자(UUID), 단말기
                        정보(단말기명, OS, 앱 버전), 서비스 이용기록(접속로그,
                        쿠키, IP), 채팅내역
                      </p>
                    </td>
                    <td>
                      <p>
                        이용자 식별, 서비스 이용에 따른 정보 제공 및 부정이용
                        확인∙방지
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>회원/비회원 공통(자동차 서비스 이용 시)</p>
                    </td>
                    <td>
                      <p>
                        이름, 연락처(휴대전화번호), 차량정보, 지역정보,
                        사진정보, 기타 차량설명
                      </p>
                    </td>
                    <td>
                      <p>자동차 관련 서비스 이용 및 거래 시 정보 제공</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>회원/비회원 공통(모바일 서비스 이용 시)</p>
                    </td>
                    <td>
                      <p>
                        이름, 연락처(휴대전화번호), 모바일 기기 정보, 기타
                        모바일 기기 설명
                      </p>
                    </td>
                    <td>
                      <p>모바일 서비스 이용 및 거래 시 정보 제공</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>회원/비회원 공통</p>
                    </td>
                    <td>
                      <p>
                        이름, 휴대전화번호, 이메일 등, 연락처, 중복가입번호(DI),
                        연계정보(CI), 배송지주소, 계좌정보(예금주, 은행명,
                        계좌번호), 위치정보
                      </p>
                    </td>
                    <td>
                      <p>
                        상품 및 경품 배송(반품/환불), 배송지 및 연락처 확인,
                        대금결제 서비스 관련 상담 및 민원사항 처리
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>3.</strong>
          </span>
          <p>
            <strong>개인정보 수집방법</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            회사는 개인정보를 회원가입 절차, 상담절차, 이벤트 행사, 영업업무
            위탁사 또는 제휴사, 서비스 이용 등에서 회원이 직접 입력한 정보를
            수집하며 이동 전화 및 유∙무선 인터넷 서비스를 사용할 때 생성정보
            수집 도구를 통한 방법(쿠키) 등으로도 개인정보를 수집합니다.
          </p>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>4.</strong>
          </span>
          <p>
            <strong>개인정보 보유 및 이용기간</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                회사는 원칙적으로 이용자의 개인정보를 고지 및 동의받은 기간 동안
                보유 및 이용합니다. 개인정보의 수집 및 이용목적 달성, 보유기간
                만료, 회원의 수집 및 이용 동의 철회 시 수집된 개인정보는
                열람하거나 이용할 수 없도록 파기 처리합니다.
              </p>
              <ul className="list_desc mt5">
                <li className="pd_l20">
                  <span className="desc">가.</span>
                  <p>
                    <strong>회사 방침에 의한 보유 정보</strong>
                  </p>
                  <ul className="list_desc mt5">
                    <li className="pd_l10">
                      <span className="desc">
                        <strong>∙</strong>
                      </span>
                      <p>
                        비정상적인 회원탈퇴 등으로 인한 피해 예방 : 회원탈퇴
                        신청 후 3일
                      </p>
                    </li>
                    <li className="pd_l10 mt5">
                      <span className="desc">
                        <strong>∙</strong>
                      </span>
                      <p>회원의 부정이용 이슈 방지 : 회원 탈퇴완료 후 6개월</p>
                    </li>
                    <li className="pd_l10 mt5">
                      <span className="desc">
                        <strong>∙</strong>
                      </span>
                      <p>서비스 부정이용 방지 : 서비스 이용 기록 5년 </p>
                    </li>
                  </ul>
                </li>
                <li className="pd_l20 mt10">
                  <span className="desc">나.</span>
                  <p>
                    <strong>관계법령에 의한 정보보유</strong>
                  </p>
                  <p>
                    상법, 전자상거래 등에서의 소비자보호에 관한 법률 등
                    관계법령의 규정에 의하여 보존할 필요가 있는 경우 회사는
                    관계법령에서 정한 일정한 기간 동안 회원정보를 보관합니다. 이
                    경우 회사는 보관하는 정보를 그 보관의 목적으로만 이용하며
                    보존기간은 아래와 같습니다.
                  </p>
                  <table className={classNames('mt10', 'termsTable')}>
                    <thead>
                      <tr>
                        <th className={'w40'}>
                          <p>
                            <strong>보유정보</strong>
                          </p>
                        </th>
                        <th className={'w20'}>
                          <p>
                            <strong>보유기간</strong>
                          </p>
                        </th>
                        <th className={'w40'}>
                          <p>
                            <strong>근거법령</strong>
                          </p>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <p>표시·광고에 관한 기록</p>
                        </td>
                        <td>
                          <p>6개월</p>
                        </td>
                        <td rowSpan={3}>
                          <p>전자상거래 등에서의 소비자보호에 관한 법률</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>
                            계약 또는 청약철회, 대금결제 및 재화 등의 공급에
                            관한 기록
                          </p>
                        </td>
                        <td>
                          <p>5년</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>소비자의 불만 또는 분쟁처리에 관한 기록</p>
                        </td>
                        <td>
                          <p>3년</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>로그인 기록</p>
                        </td>
                        <td>
                          <p>3개월</p>
                        </td>
                        <td>
                          <p>통신비밀보호법</p>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <p>전자금융거래기록</p>
                        </td>
                        <td>
                          <p>5년</p>
                        </td>
                        <td>
                          <p>전자금융거래법</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                회원이 1년간 회사의 서비스 이용 기록이 없는 회원의 개인정보는
                별도로 분리하여 안전하게 관리하게 되며, 대상자에게는 분리보관
                처리일을 기준으로 최소 30일 이전에 이메일 등의 방법으로 안내를
                합니다. 이를 위해 이용자는 회사에 정확한 연락처 정보를
                제공/수정하여야 합니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>5.</strong>
          </span>
          <p>
            <strong>개인정보의 제3자 제공</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                회사는 이용자들의 개인정보를 이용약관, 「 개인정보의 수집 및
                이용 목적」에서 고지한 범위 내에서 사용하며, 회원의 사전 동의
                없이 동 범위를 초과하여 이용하거나 원칙적으로 이용자의
                개인정보를 제3자에게 제공하지 않습니다. 다만, 이용자의 동의가
                있거나 법령에 의하여 정해진 절차에 따라 정보를 요청받은 경우는
                예외로 하며, 이 경우 주의를 기울여 개인정보를 이용 및 제공할 수
                있습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>개인정보 제3자 제공 동의</p>
              <table className={classNames('mt10', 'termsTable')}>
                <thead>
                  <tr>
                    <th className={'w25'}>
                      <p>
                        <strong>개인정보를 제공받는 자</strong>
                      </p>
                    </th>
                    <th className={'w25'}>
                      <p>
                        <strong>
                          개인정보를 제공받는자의 개인정보 이용목적
                        </strong>
                      </p>
                    </th>
                    <th className={'w25'}>
                      <p>
                        <strong>제공하는 개인정보 항목</strong>
                      </p>
                    </th>
                    <th className={'w25'}>
                      <p>
                        <strong>
                          개인정보를 제공받는 자의 개인정보 보유 및 이용기간
                        </strong>
                      </p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <p>㈜KB국민카드</p>
                    </td>
                    <td>
                      <p>중고안심결제 서비스 제공</p>
                    </td>
                    <td>
                      <p>
                        CI, 이름, ID, 성별, 생년월일, 이메일, 휴대폰번호, 통신사
                        구분, 내외국인 구분, 판매자 이메일 수신 여부
                      </p>
                    </td>
                    <td>
                      <p>서비스 목적 달성 시까지</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>㈜바름파트너스</p>
                    </td>
                    <td>
                      <p>차량 진단 서비스 제공</p>
                    </td>
                    <td>
                      <p>
                        이름, 휴대폰번호, 차량번호, 제조사, 모델, 등급, 세부등급
                      </p>
                    </td>
                    <td>
                      <p>서비스 목적 달성 시까지</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">③</span>
              <p>
                회사는 제공하는 서비스를 통해 거래가 성사되었을 때에는 이용자의
                요청에 따라 쌍방 당사자간의 물품거래와 배송과 관련한 정보를
                필요한 범위 내에서 쌍방당사자에게 제공합니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">④</span>
              <p>
                개인정보 제공 현황은 제휴관계의 개시 또는 종료에 따라 변동될 수
                있으며 개인정보 제공과 함께 목록에 게시됩니다. 제휴관계가
                종료되면 개인정보의 파기와 함께 목록에서 삭제됩니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">⑤</span>
              <p>
                이용자는 개인정보의 제3자 제공에 대하여 동의를 하지 않을 수
                있고, 언제든지 제3자 제공 동의를 철회할 수 있습니다. 동의를
                거부하시는 경우에도 회원가입서비스는 이용하실 수 있으나, 제3자
                제공에 기반한 관련 서비스의 이용/제공이 제한될 수 있습니다. 기타
                개인정보 제3자 제공에 대한 변동사항은 공지 및 별도 통지를 할
                예정입니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>6.</strong>
          </span>
          <p>
            <strong>개인정보의 처리위탁</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                회사는 원활하고 향상된 서비스를 제공하기 위해 개인정보 처리를
                제3자에게 위탁할 수 있습니다. 이 경우 회사는 다음 각호에서 정한
                위탁에 관한 사항을 이용자에게 공개합니다.
              </p>
              <ul className="list_desc mt10">
                <li className="pd_l20">
                  <span className="desc">가.</span>
                  <p>개인정보 처리위탁을 받는 자</p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">나.</span>
                  <p>개인정보 처리위탁을 하는 업무의 내용</p>
                </li>
              </ul>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                회사는 개인정보의 처리와 관련하여 아래와 같이 업무를 위탁하고
                있으며, 관계법령에 따라 위탁 계약 시 개인정보가 안전하게 관리될
                수 있도록 필요한 조치를 하고 있습니다. 회사는 위탁 계약 시
                수탁자의 개인정보 보호조치 능력을 고려하고, 개인정보의 안전한
                관리 및 파기 등 수탁자의 의무 이행 여부를 주기적으로 확인합니다.
                또한 위탁처리하는 정보는 원활한 서비스를 제공하기 위하여 필요한
                최소한의 정보에 국한됩니다.
              </p>
              <table className={classNames('mt10', 'termsTable')}>
                <thead>
                  <tr>
                    <th className={'w35'}>
                      <p>
                        <strong>수탁자</strong>
                      </p>
                    </th>
                    <th className={'w30'}>
                      <p>
                        <strong>위탁사무 및 목적</strong>
                      </p>
                    </th>
                    <th className={'w40'}>
                      <p>
                        <strong>보유 및 이용기간</strong>
                      </p>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <p>㈜다우기술</p>
                    </td>
                    <td>
                      <p>안전결제 결제서비스 제공</p>
                    </td>
                    <td>
                      <p>회원탈퇴 및 위탁 계약 만료까지</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>㈜BGF post</p>
                    </td>
                    <td>
                      <p>택배 서비스 제공</p>
                    </td>
                    <td>
                      <p>회원탈퇴 및 위탁 계약 만료까지</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>㈜GS네크웍스</p>
                    </td>
                    <td>
                      <p>택배 서비스 제공</p>
                    </td>
                    <td>
                      <p>회원탈퇴 및 위탁 계약 만료까지</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>㈜KG모빌리언스</p>
                    </td>
                    <td>
                      <p>
                        회원관리 회원제 서비스 이용에 따른 본인확인(휴대전화
                        인증)
                      </p>
                    </td>
                    <td>
                      <p>회원탈퇴 및 위탁 계약 만료까지</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>㈜세틀뱅크</p>
                    </td>
                    <td>
                      <p>계좌등록 및 환불계좌 인증</p>
                    </td>
                    <td>
                      <p>회원탈퇴 및 위탁 계약 만료까지</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>㈜에이씨엘</p>
                    </td>
                    <td>
                      <p>모바일 거래 서비스 제공</p>
                    </td>
                    <td>
                      <p>회원탈퇴 및 위탁 계약 만료까지</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>㈜더치트</p>
                    </td>
                    <td>
                      <p>사기피해사례 검색</p>
                    </td>
                    <td>
                      <p>회원탈퇴 및 위탁 계약 만료까지</p>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <p>㈜더블퀘스천</p>
                    </td>
                    <td>
                      <p>이용정책 위반 모니터링</p>
                    </td>
                    <td>
                      <p>회원탈퇴 및 위탁 계약 만료까지</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>7.</strong>
          </span>
          <p>
            <strong>개인정보 파기 절차 및 방법</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                회사는 개인정보 보유기간의 경과, 처리목적 달성 등 개인정보가
                불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                정보주체로부터 동의 받은 개인정보 보유기간이 경과하거나
                처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를
                계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의
                데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">③</span>
              <p>
                회사는 전자적 파일 형태로 기록․저장된 개인정보는 기록을 재생할
                수 없도록 파기하며, 종이 문서에 기록․저장된 개인정보는 분쇄기로
                분쇄하거나 소각하여 파기합니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>8.</strong>
          </span>
          <p>
            <strong>이용자의 권리</strong>
          </p>
        </dt>
        <dd className="mt10">
          <ul className="list_desc">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                이용자는 언제든지 사이트의 “정보수정”을 통하여 회원의 개인정보를
                열람, 정정 처리할 수 있으며, 전자우편 또는 서면으로 요청하신
                경우 열람, 정정, 삭제 처리합니다. 단, 회원 아이디(ID), 성명은
                정정이 불가능하며, 개명으로 인한 성명 변경 및 행정상의 문제로
                인한 변경은 예외적으로 허용될 수 있습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                이용자의 개인정보가 제3자에게 제공되거나 처리 위탁된 경우
                이용자는 회사 또는 ‘제3자’/’수탁자’에게 파기를 요청할 수
                있습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">③</span>
              <p>
                기타 법률에 따라 정정 또는 삭제가 금지되거나 제한되어 있는
                경우에는 해당 처리가 제한될 수 있습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">④</span>
              <p>
                개인정보 오류에 대한 정정요청한 경우에는 다른 법률에 따라
                개인정보의 제공을 요청받는 경우가 아닌 한 정정을 완료하기 전까지
                해당개인정보를 이용 또는 제공하지 않습니다. 만약 잘못된
                개인정보를 이미 제공한 경우에는 정정 처리 결과를 제3자에게
                통지하여 정정이 이루어지도록 하겠습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">⑤</span>
              <p>
                이용자는 언제든지 사이트의 개인정보에 대하여 처리의 정지를
                요구할 수 있습니다. 다만 아래의 경우에 해당하는 경우 처리정지
                요구를 거절할 수 있습니다.
              </p>
              <ul className="list_desc mt10">
                <li className="pd_l20">
                  <span className="desc">가.</span>
                  <p>
                    법률에 특별한 규정이 있거나 법령상 의무를 준수하기 위하여
                    불가피한 경우
                  </p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">나.</span>
                  <p>
                    다른 사람의 생명·신체를 해할 우려가 있거나 다른 사람의
                    재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우
                  </p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">다.</span>
                  <p>
                    개인정보를 처리하지 아니하면 정보주체와 약정한 서비스를
                    제공하지 못하는 등 계약의 이행이 곤란한 경우로서 정보주체가
                    그 계약의 해지 의사를 명확하게 밝히지 아니한 경우
                  </p>
                </li>
              </ul>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">⑥</span>
              <p>
                회원가입 등을 통해 개인정보의 수집·이용·제공에 대해 회원이
                동의한 내용을 언제든지 철회할 수 있습니다. 동의철회는 회사
                사이트 내 “회원 탈퇴 신청”을 클릭하거나 서면, 이메일 등으로
                연락하면 지체 없이 개인정보의 삭제 등 필요한 조치를 하겠습니다.
                다만 법률 또는 약관의 규정에 따라 회사가 회원의 개인정보를
                보존하여야 하는 경우에는 해당 처리가 제한될 수 있습니다. 이 경우
                회원은 본인 식별을 위하여 반드시 회원아이디(ID)와 본인확인
                식별정보를 밝혀야 하며, 철회로 인해 서비스에 다소 제약이 있거나
                일부 서비스를 이용하지 못할 수 있습니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>9.</strong>
          </span>
          <p>
            <strong>개인정보 보호를 위한 기술 및 관리적 대책</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            회사에서는 회원의 개인정보를 보호하기 위해 기술적 대책과 관리적
            대책을 마련하고 있으며, 이를 적용하고 있습니다.
          </p>
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>기술적 대책</p>
              <p>
                회사는 회원의 개인정보를 처리할 때 개인정보가 분실, 도난, 유출,
                변조 또는 훼손되지 않도록 다음과 같은 기술적 대책을 마련하여
                개인정보의 안전성을 확보하고 있습니다.
              </p>
              <ul className="list_desc mt10">
                <li className="pd_l20">
                  <span className="desc">가.</span>
                  <p>비밀번호 보호, 중요 파일 및 데이터 암호화 등 보안 조치</p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">나.</span>
                  <p>바이러스 침해 방지용 백신프로그램 이용</p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">다.</span>
                  <p>
                    암호화 알고리즘을 통한 네트워크상 개인정보 정보 보안장치(SSL
                    또는 SET) 채택
                  </p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">라.</span>
                  <p>
                    해킹 등 외부침입 방지를 위하여 침입차단시스템, 취약점 분석
                    시스템 도입
                  </p>
                </li>
              </ul>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>관리적 대책</p>
              <p>
                회사는 회원의 개인정보에 대한 접근권한을 최소한의 인원으로
                제한하고 있으며 이에 해당하는 자는 다음과 같습니다.
              </p>
              <ul className="list_desc mt10">
                <li className="pd_l20">
                  <span className="desc">가.</span>
                  <p>이용자를 직접 상대로 하여 마케팅 업무를 수행하는 자</p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">나.</span>
                  <p>개인정보보호책임자 등 개인정보보호업무를 수행하는 자</p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">다.</span>
                  <p>개인정보 교육 실시 및 접근권한 관리, 접근통제</p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">라.</span>
                  <p>기타 업무상 개인정보의 처리가 불가피한 자</p>
                </li>
              </ul>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>10.</strong>
          </span>
          <p>
            <strong>이용자의 의무</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            이용자는 자신의 개인정보를 보호할 의무가 있으며, 회사의 귀책사유가
            없이 ID, 비밀번호, 접근매체 등의 양도·대여·분실이나 로그인 상태에서
            이석 등 이용자 본인의 부주의나 관계법령에 의한 보안조치로 차단할 수
            없는 방법이나 기술을 사용한 해킹 등 회사가 상당한 주의에도 불구하고
            통제할 수 없는 인터넷 상의 문제 등으로 개인정보가 유출되어 발생한
            문제에 대해 회사는 책임을 지지 않습니다.
          </p>
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                이용자는 자신의 개인정보를 최신의 상태로 유지해야 하며, 이용자의
                부정확한 정보 입력으로 발생하는 문제의 책임은 이용자 자신에게
                있습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                타인의 개인정보를 도용한 회원가입 또는 ID 등을 도용하여 결제
                처리시 이용자자격 상실과 함께 관계법령에 의거하여 처벌될 수
                있습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">③</span>
              <p>
                이용자는 ID, 비밀번호 등에 대해 보안을 유지할 책임이 있으며
                제3자에게 이를 양도하거나 대여할 수 없습니다. 이용자는 회사의
                개인정보보호정책에 따라 보안을 위해 비밀번호의 주기적 변경에
                협조할 의무가 있습니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">④</span>
              <p>
                이용자는 회사의 서비스를 이용한 후에는 반드시 로그인 계정을
                종료하고 웹 브라우저 프로그램을 종료해야 합니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">⑤</span>
              <p>
                이용자는 게시물을 포함한 타인의 개인정보를 침해하거나 훼손하지
                않아야 합니다. 만약 이 같은 책임을 다하지 못하고 타인의 정보를
                훼손할 때에는 『정보통신망 이용촉진 및 정보보호 등에 관한
                법률』, 『개인정보 보호법』등에 의해 처벌받을 수 있습니다.
              </p>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>11.</strong>
          </span>
          <p>
            <strong>링크(사이트)에 대한 안내</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            회사가 회원에게 다른 회사의 웹사이트 또는 자료에 대한 링크를
            제공하는 경우, 회사는 외부사이트 및 자료에 대한 아무런 통제권이
            없으므로 그로부터 제공받는 서비스나 자료의 유용성에 대해 책임질 수
            없으며 보증할 수 없습니다. 회사가 포함하고 있는 링크를
            클릭(click)하여 타사이트(site)의 페이지로 옮겨 갈 경우 해당 사이트의
            개인정보보호정책은 회사와 무관하므로 새로 방문한 사이트의 정책을
            검토해 보시기 바랍니다.
          </p>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>12.</strong>
          </span>
          <p>
            <strong>개인정보보호 책임자</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보
            처리와 관련한 이용자의 불만접수 및 처리, 피해구제 등을 위하여 아래와
            같이 개인정보 보호책임자를 지정하고 있습니다.
          </p>
          <dl className="mt10">
            <dt>
              <p>
                <strong>[개인정보보호 책임자]</strong>
              </p>
            </dt>
            <dd>
              <p>성명 : 김 웅</p>
              <p>전화번호 : 070-5066-2278</p>
              <p>팩스 : 070-8220-5331</p>
              <p>전자우편 : joongna@joonggonara.co.kr</p>
            </dd>
            <dt className="mt10">
              <p>
                <strong>[개인정보 민원처리 담당부서]</strong>
              </p>
            </dt>
            <dd>
              <p>부서명 : 중고나라 고객센터</p>
              <p>전화번호 : 070-5066-2278</p>
              <p>전자우편 : joongna@joonggonara.co.kr</p>
            </dd>
          </dl>
          <ul className="list_desc mt10">
            <li className="pd_l20">
              <span className="desc">①</span>
              <p>
                이용자는 회사의 서비스이용과 관련된 모든 개인정보보호 문의
                사항에 대하여 아래의 개인정보 보호책임자에게 문의하실 수
                있습니다. 회사는 정보주체의 문의에 대해 지체없이 답변 및
                처리해드릴 것입니다.
              </p>
            </li>
            <li className="pd_l20 mt10">
              <span className="desc">②</span>
              <p>
                기타 개인정보 침해 신고나 상담이 필요한 경우에는 아래 기관에
                문의하여 주시기 바랍니다.
              </p>
              <ul className="list_desc mt5">
                <li className="pd_l20">
                  <span className="desc">가.</span>
                  <p>개인정보 분쟁조정위원회 : www.kopico.go.kr / 1833-6972</p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">나.</span>
                  <p>개인정보 침해신고센터 : privacy.kisa.or.kr / 118</p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">다.</span>
                  <p>대검찰청 사이버수사과 : www.spo.go.kr/ 02-3480-3571</p>
                </li>
                <li className="pd_l20 mt5">
                  <span className="desc">라.</span>
                  <p>경찰청 사이버안전국 : cyberbureau.police.go.kr / 182</p>
                </li>
              </ul>
            </li>
          </ul>
        </dd>
        <dt className="relative pd_l20 mt10">
          <span className="desc">
            <strong>13.</strong>
          </span>
          <p>
            <strong>개인정보처리방침의 변경</strong>
          </p>
        </dt>
        <dd className="mt10">
          <p>
            본 개인정보처리방침은 관계법령 및 지침의 변경 또는 회사의 필요 등에
            의하여 내용의 추가, 삭제 및 수정이 생길 수 있습니다. 이 경우
            홈페이지 또는 이메일을 통해 공지합니다.
          </p>
          <p className="mt10">공고일자 : 2021년 06월 14일</p>
          <p className="mt5">시행일자 : 2021년 06월 21일</p>
        </dd>
      </dl>
    </article>
  );
};

export default PrivacyPolicy_v18;
